/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
* last modification: jgaliano@ecommedia.es Thu Jan 12 09:23
*/

(function() {
  const GridSlider = customElements.get('grid-slider');
  if (GridSlider) {
    GridSlider.prototype.buttonArrowClickEvent = function(t) {
      t.preventDefault();
      const isNext = t.target.hasAttribute('data-button-next');
      const scrollLeft = this.slider.scrollLeft;
      const tolerance = 10; 
      let targetSlide = null;
      if (isNext) {
       
        for (let i = 0; i < this.slides.length; i++) {
          if (this.slides[i].offsetLeft > scrollLeft + tolerance) {
            targetSlide = this.slides[i];
            break;
          }
        }
      } else {
        
        for (let i = this.slides.length - 1; i >= 0; i--) {
          if (this.slides[i].offsetLeft < scrollLeft - tolerance) {
            targetSlide = this.slides[i];
            break;
          }
        }
      }
        if (targetSlide) {
        this.goToSlide(targetSlide);
      }
    };
  }
/*
 * Forzar selección de talla
 */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const currentLang = document.documentElement.lang.substring(0, 2);
    const translations = {
      'es': 'Por favor, selecciona una talla.',
      'en': 'Please select a size.',
      'fr': 'Veuillez sélectionner une taille.',
      'de': 'Bitte wählen Sie eine Größe.',
      'it': 'Si prega di selezionare una taglia.',
      'pt': 'Por favor, selecione um tamanho.'
    };
    const errorMessageText = translations[currentLang] || translations['en'];
    function deselectVariantsOnLoad() {
      const variantFieldsets = document.querySelectorAll('.radio__fieldset');
      if (variantFieldsets.length === 0) return;

      variantFieldsets.forEach(fieldset => {
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        const legendValue = fieldset.querySelector('.radio__legend__value');

        radios.forEach(radio => {
          radio.checked = false;
          radio.addEventListener('change', function() {
             clearErrors();
             if(legendValue) legendValue.textContent = this.nextElementSibling.textContent.trim();
          });
        });
        if(legendValue) legendValue.textContent = '';
      });
    }
    function initClickInterceptor() {
      const addToCartButtons = document.querySelectorAll('button[name="add"], .product__submit__add, [data-add-to-cart]');

      addToCartButtons.forEach(btn => {
        btn.addEventListener('click', function(e) {
          const allFieldsets = document.querySelectorAll('.radio__fieldset');
          const visibleFieldsets = Array.from(allFieldsets).filter(fs => fs.offsetParent !== null);

          let hasSizeOption = false;
          let allGroupsSelected = true;

          if (visibleFieldsets.length > 0) {
            hasSizeOption = true; 
            visibleFieldsets.forEach(fs => {
               const hasRadios = fs.querySelector('input[type="radio"]');
               if (hasRadios) {
                 const checked = fs.querySelector('input[type="radio"]:checked');
                 if (!checked) {
                   allGroupsSelected = false;
                   fs.classList.add('variant-error-border');
                 } else {
                   fs.classList.remove('variant-error-border');
                 }
               }
            });
          } else {
            allGroupsSelected = true;
          }
            if (hasSizeOption && !allGroupsSelected) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            showErrorMessage(btn, errorMessageText);
            return false;
          }
        }, true);
      });
    }

    function showErrorMessage(btn, message) {
      clearErrors();
      
      const errorDiv = document.createElement('div');
      errorDiv.className = 'custom-variant-error-message';
      errorDiv.innerHTML = `<span style="margin-right:5px;">⚠️</span> ${message}`;
      
      Object.assign(errorDiv.style, {
        color: '#D20000',
        fontWeight: '600',
        marginTop: '10px',
        fontSize: '13px',
        textAlign: 'center',
        width: '100%',
        display: 'block'
      });

      btn.parentElement.insertBefore(errorDiv, btn);
    }

    function clearErrors() {
      const msgs = document.querySelectorAll('.custom-variant-error-message');
      msgs.forEach(m => m.remove());
      
      const borders = document.querySelectorAll('.variant-error-border');
      borders.forEach(b => b.classList.remove('variant-error-border'));
    }

    const style = document.createElement('style');
    style.innerHTML = `
      .variant-error-border { border: 1px solid #D20000 !important; border-radius: 4px; padding: 5px; }
      .custom-variant-error-message { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
      @keyframes shake {
        10%, 90% { transform: translate3d(-1px, 0, 0); }
        20%, 80% { transform: translate3d(2px, 0, 0); }
        30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
        40%, 60% { transform: translate3d(4px, 0, 0); }
      }
    `;
    document.head.appendChild(style);
    deselectVariantsOnLoad();
    initClickInterceptor();

  });
})();

//Product GRID: Add discount percentage if there's a Sale price.
(function() {
  function injectStyles() {
    if (document.getElementById('custom-discount-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'custom-discount-styles';
    style.innerHTML = `
      .custom-sale-badge {
        background-color: #cc0000;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 3px;
        margin-left: 8px;
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
        position: relative; /* Fix z-index issues */
        z-index: 2;         /* Ensure it sits on top */
      }
    `;
    document.head.appendChild(style);
  }
  function updateProduct(item) {
    if (item.querySelector('.custom-sale-badge')) return;

    const oldPriceEl = item.querySelector('.old-price');
    const newPriceEl = item.querySelector('.new-price');
    const priceContainer = item.querySelector('.price');

    if (!oldPriceEl || !newPriceEl || !priceContainer) return;

    const oldVal = getPriceValue(oldPriceEl.innerText);
    const newVal = getPriceValue(newPriceEl.innerText);

    if (oldVal > 0 && newVal > 0 && oldVal > newVal) {
      const percent = Math.round(((oldVal - newVal) / oldVal) * 100);

      if (percent > 0) {
        const badge = document.createElement('span');
        badge.className = 'custom-sale-badge';
        badge.innerText = '-' + percent + '%';
        priceContainer.appendChild(badge);
      }
    }
  }

  function checkAllProducts() {
    const items = document.querySelectorAll('.product-item');
    items.forEach(function(item) {
      updateProduct(item);

      if (!item.hasAttribute('data-hover-protected')) {
        item.setAttribute('data-hover-protected', 'true');
        item.addEventListener('mouseenter', function() {
          setTimeout(function() { updateProduct(item); }, 50); 
        });
      }
    });
  }

  function getPriceValue(priceStr) {
    if (!priceStr) return 0;
    let clean = priceStr.replace(/[^0-9.,]/g, '');
    if (!clean) return 0;
    
    if (clean.indexOf(',') > -1 && clean.indexOf('.') > -1) {
        if (clean.lastIndexOf(',') > clean.lastIndexOf('.')) {
            clean = clean.replace(/\./g, '').replace(',', '.');
        } else {
            clean = clean.replace(/,/g, '');
        }
    } else if (clean.indexOf(',') > -1) {
        clean = clean.replace(',', '.');
    }
    return parseFloat(clean);
  }

  injectStyles();

  document.addEventListener('DOMContentLoaded', checkAllProducts);
  window.addEventListener('load', checkAllProducts);
  
  const observer = new MutationObserver(function(mutations) {
    checkAllProducts();
  });
  
  observer.observe(document.body, { childList: true, subtree: true });

})();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();